<template src="./Add.html"></template>

<script>
import { showAlert } from "@/utils/helpers";

export default {
  created() {
    this.$store.dispatch("lookups/getStores");
  },
  computed: {
    stores() {
      return this.$store.state.lookups.stores;
    },
    toStores() {
      return this.$store.state.lookups.stores.filter(x => x.value != this.vm.fromStoreId);
    },
  },
  data() {
    return {
      stock:[],
      formDialog: false,
      vm: {
        fromStoreId: null,
        toStoreId: null,
        items: []
      },
      medicine: {
        medicineId: null,
        medicineName: null,
        batchNo: null,
        quantity: null,
        expirationDate: null,
        availableQuantity: null,
      },
      indexItem: null,
      editFlag: false,
      headers: [
        { text: 'اسم الدواء', value: 'medicineName' },
        { text: ' رقم التشغيلة', value: 'batchNo' },
        { text: 'الكمية', value: 'quantity' },
        { text: 'تاريخ  انتهاء الصلاحية ', value: 'expirationDate' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
      headersStock: [
        { text: 'اسم الدواء', value: 'medicineName' },
        { text: ' رقم التشغيلة', value: 'batchNo' },
        { text: 'الكمية المتاحة', value: 'availableQuantity' },
        { text: 'تاريخ  انتهاء الصلاحية ', value: 'expirationDate' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],

    };
  },
  methods: {
    confirm() {
      if (this.vm.items.length == 0) {
        showAlert(`يجب ادخال عنصر واحد على الاقل`);
        return false;
      }
      this.$store
        .dispatch("stockTransfers/add", this.vm)
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },

    getMedicinesStock() {
      this.stock=[];
      this.vm.toStoreId = null;
      this.$store
        .dispatch("stockTransfers/getMedicinesStock", this.vm.fromStoreId)
        .then((res) => {
          this.stock = res;
        })
        .catch(() => { });
    },
    openDialog(item) {

      this.medicine.medicineId = item.medicineId;
      this.medicine.medicineName = item.medicineName;
      this.medicine.batchNo = item.batchNo;
      this.medicine.availableQuantity = item.availableQuantity;
      this.medicine.expirationDate = item.expirationDate;
      this.formDialog = true;
    },
    confirmFormDialog() {
      this.$refs.form.validate().then(valid => {
        if (valid) {
      let FirstAddItem = true

      let ItemIndex = this.stock.findIndex((el) => {
        return (
          el.medicineId == this.medicine.medicineId &&
          el.expirationDate == this.medicine.expirationDate &&
          el.batchNo == this.medicine.batchNo
        )
      })

      if (this.stock[ItemIndex].medicineId == this.medicine.medicineId &&
        this.stock[ItemIndex].batchNo == this.medicine.batchNo &&
        this.stock[ItemIndex].expirationDate == this.medicine.expirationDate
      ) {
        if (this.stock[ItemIndex].availableQuantity >= this.medicine.quantity) {
          this.stock[ItemIndex].availableQuantity -= Number(this.medicine.quantity)
          if (this.vm.items.length > 0) {
            this.vm.items.forEach((x) => {
              if (x.medicineId == this.medicine.medicineId && x.batchNo == this.medicine.batchNo && x.expirationDate == this.medicine.expirationDate) {
                x.quantity = Number( x.quantity) +Number(this.medicine.quantity)
                FirstAddItem = false
              }
            })
          }
        } else {
          showAlert('الكمية المدخلة أكبر من الكمية المتاحة')
          FirstAddItem = false
          return false;
        }
      }

      if (FirstAddItem) {
        this.vm.items.push({ ...this.medicine })
      }

    
      this.cancelFormDialog()

    }
  })
    },

    cancelFormDialog() {
      this.medicine = {
        medicineId: null,
        medicineName: null,
        batchNo: null,
        quantity: null,
        expirationDate: null,
        availableQuantity: null,
      };
      this.$refs.form.reset();

      this.formDialog = false;
    },

    removeItem(index,item) {
      let ItemIndex = this.stock.findIndex((el) => {
        return (
          el.medicineId == item.medicineId &&
          el.batchNo == item.batchNo &&
          el.expirationDate == item.expirationDate
        )
      })

      this.stock[ItemIndex].availableQuantity += Number(item.quantity)
      this.vm.items.splice(index, 1);
    },

    back() {
      this.$emit("back");
    },
  },
};
</script>